export default __webpack_public_path__ + "static/media/word_top.b96f296b.png";